import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  menuButton: {
    '& svg': {
      transition: `fill ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
    },
    '&:hover, &:focus': {
      '& svg': {
        fill: `rgb(${theme.palette.white})`,
      },
      backgroundColor: 'none',
      outline: 'none',
    },
    backgroundColor: 'transparent',
    border: '0',
    boxSizing: 'border-box',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '1.75',
    minWidth: '18px',
    padding: 0,
    position: 'relative',
    zIndex: 11,
  },
  menuItem: {
    '&:hover,&:focus': {
      background: `rgb(${theme.palette.tarawera})`,
      outline: 0,
      textDecoration: 'none',
    },
    color: `rgb(${theme.palette.gallery})`,
    display: 'block',
    fontSize: '0.875rem',
    letterSpacing: '0.11rem',
    padding: '0.35rem 1rem',
    textDecoration: 'none',
    transition: `all ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
  },
  menuItemHeader: {
    color: `rgb(${theme.palette.doveGray})`,
    display: 'block',
    margin: '1.25rem 1rem 0.5rem 1rem',
  },
  menuListItem: {
    marginBottom: 0,
  },
  siteMenu: {
    '&:focus-within': {
      //   maxHeight: '470px !important',
      opacity: '1 !important',
    },
    '&[aria-hidden="false"]': {
      pointerEvents: 'auto',
    },
    '&[aria-hidden="true"]': {
      pointerEvents: 'none',
    },
    fontFamily: theme.typography.fontFamily,
    background: `rgb(${theme.palette.black})`,
    borderLeft: `1px solid rgb(${theme.palette.mineShaft})`,
    boxShadow: `0px 50px 50px rgb(${theme.palette.codGray})`,
    left: '-1rem',
    listStyleType: 'none',
    margin: 0,
    minWidth: '210px',
    overflow: 'hidden',
    padding: '3.5rem 0 1rem 0;',
    position: 'absolute',
    textTransform: 'uppercase',
    top: 0,
    width: '100%',
    willChange: 'max-height',
    zIndex: 10,
  },
  siteNavigation: {
    marginRight: '1rem',
    position: 'relative',
  },
  subMenu: {
    listStyleType: 'none',
    margin: 0,
  },
  subMenuItem: {
    marginBottom: 0,
  },
}))

export default useStyles
